/* actionsIare
This defines all actions that are available within the IARE interqctive
system. Many action handlers in various components make use of these
"Action constants"
 */
export const ACTIONS_IARE = {

    _TEST_MESSAGE: {
        key:"_TEST_MESSAGE",
    },

    REMOVE_ALL_FILTERS: {
        key:"REMOVE_ALL_FILTERS",
    },

    SHOW_MESSAGE: {
        key:"SHOW_MESSAGE",
    },

    FILTER_BY_REFERENCE_STATS: {
        key:"FILTER_BY_REFERENCE_STATS",
    },

    SHOW_REFERENCE_VIEW: {
        key:"SHOW_REFERENCE_VIEW",
    },

    SHOW_REFERENCE_VIEW_FOR_URL: {
        key:"SHOW_REFERENCE_VIEW_FOR_URL",
    },

    CHANGE_REF_VIEW_SELECTION: {
        key:"CHANGE_REF_VIEW_SELECTION",
    },

    SET_ACTIONABLE_FILTER: {
        key: "SET_ACTIONABLE_FILTER"
    },

    SET_PAY_LEVEL_DOMAIN_FILTER: {
        key: "SET_PAY_LEVEL_DOMAIN_FILTER"
    },

    SET_PAPERS_FILTER: {
        key: "SET_PAPERS_FILTER"
    },

    SET_PERENNIAL_FILTER: {
        key: "SET_PERENNIAL_FILTER"
    },

    SET_TLD_FILTER: {
        key: "SET_TLD_FILTER"
    },

    SET_BOOKS_FILTER: {
        key: "SET_BOOKS_FILTER"
    },

    SET_TEMPLATE_FILTER: {
        key: "SET_TEMPLATE_FILTER"
    },

    GOTO_CITE_REF: {
        key: "GOTO_CITE_REF"
    },

    GOTO_WIKI_SECTION: {
        key: "GOTO_WIKI_SECTION"
    },

    EDIT_WIKI_SECTION: {
        key: "EDIT_WIKI_SECTION"
    },

    SAVE_WIKITEXT: {
        key: "SAVE_WIKITEXT"
    },

    SET_LINK_STATUS_FILTER: {
        key: "SET_LINK_STATUS_FILTER"
    },

    SET_ARCHIVE_STATUS_FILTER: {
        key: "SET_ARCHIVE_STATUS_FILTER"
    },

    SET_LIVE_STATUS_FILTER: {
        key: "SET_LIVE_STATUS_FILTER"
    },

    POPUP_SIGNALS_DETAILS: {
        key: "POPUP_SIGNALS_DETAILS"
    },

    FETCH_SIGNAL_DATA: {
        key: "FETCH_SIGNAL_DATA"
    },

    TOGGLE_SHOW_REFS: {
        key: "TOGGLE_SHOW_REFS"
    },

    TOGGLE_SHOW_FILTERS: {
        key: "TOGGLE_SHOW_FILTERS"
    },

    SORT_BY_SIGNAL: {
        key: "SORT_BY_SIGNAL"
    },

    TOGGLE_SHOW_VIEW_OPTIONS: {
        key: "TOGGLE_SHOW_VIEW_OPTIONS"
    },

}
